<template>
  <a-result status="404" sub-title="Strona nie istnieje!" title="404">
  </a-result>
</template>

<script>
export default {
  name: "Error404",
  data() {
    return {};
  },
  mounted() {
    this.$emit("loadedView");
  },
};
</script>
